import { discoveryPath } from '@logto/js';

export const getDiscoveryEndpoint = (endpoint: string) =>
	new URL(discoveryPath, endpoint).toString();
